module.exports = __webpack_public_path__ + "img/list-bullets-1.90caeab6.svg";